import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat',
  standalone: true
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number): number | string {
    const suffixes = ['', 'k', 'm', 'b', 't']; // Add more suffixes as needed

    for (let i = suffixes.length - 1; i >= 0; i--) {
      const divisor = Math.pow(10, i * 3);
      if (value >= divisor) {
        const result = (value / divisor).toFixed(1);
        return result.endsWith('.0') ? result.slice(0, -2) + suffixes[i] : result + suffixes[i];
      }
    }

    return value?.toString(); // Return as is if no suffix is applicable
  }
}
